import type { CmpHider } from './types';

export const hubspotWebInteractives: CmpHider = {
  id: 'hubspot-web-interactives',
  label: 'HubSpot Web Interactives',
  css: `
      /* HubSpot Web Interactives (popup CTAs, top/bottom banners, floating
         CTAs, loaded by the "hubspot-web-interactives-loader" script): the
         loader mounts fixed full-viewport anchors at the top and bottom of
         <body> ("#hs-web-interactives-top-anchor", z-index 9999) that hold a
         dimming backdrop ("#hs-interactives-modal-overlay", rgba(0,0,0,.7))
         and one "#hs-overlay-cta-<id>" dialog per interactive (a centred
         popup iframe, a 75px top banner). Seen on recruitee.com: the popup and
         its backdrop covered the whole preview. Hiding the anchors removes
         banners, popups and backdrop in one go; the CTA ids and the overlay
         are hidden too for builds that mount them elsewhere. The chat widget
         container is a floating overlay of the same family. While a top
         banner is "open" HubSpot pushes the site's own fixed header down by
         the banner height ("translate: 0px 110px !important" on
         ".hs-is-fixed-element", from "#hs-web-interactives-banner-style-
         element"); with the banner hidden that shift must go, and the
         html/body-prefixed selector out-specifies HubSpot's. No scroll lock
         on the sites observed. No backticks in this block: it is a JS
         template literal. */
      #hs-web-interactives-top-anchor,
      #hs-web-interactives-bottom-anchor,
      [id^="hs-web-interactives-floating-"],
      #hs-interactives-modal-overlay,
      [id^="hs-overlay-cta-"],
      #hubspot-messages-iframe-container { display: none !important; }
      html body.hs-web-interactives-top-banner-open .hs-is-fixed-element {
        translate: 0 0 !important;
      }
  `,
};
